import { Link } from "react-router-dom";
import { CalendarDays, MapPin, ArrowRight } from "lucide-react";
import StatusBadge from "./StatusBadge";
import Countdown from "./Countdown";

export default function EventCard({ event, onRegister }) {
  return (
    <div data-testid={`event-card-${event.slug}`} className="card-k group overflow-hidden transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-brand-cyan/50">
      <div className="relative h-48 overflow-hidden">
        <img src={event.image} alt={event.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/20 to-transparent" />
        <div className="absolute left-4 top-4"><StatusBadge status={event.status} /></div>
        {event.status === "coming_soon" && (
          <div data-testid={`coming-soon-ribbon-${event.slug}`} className="absolute -right-11 top-6 z-10 rotate-45 bg-gradient-to-r from-yellow-400 to-brand-olive px-12 py-1.5 text-center font-display text-xs font-bold uppercase tracking-[0.2em] text-brand-ink shadow-lg">
            Coming Soon
          </div>
        )}
        <span className="absolute right-4 top-4 rounded-full bg-brand-ink/70 px-3 py-1 font-mono text-[10px] tracking-[0.2em] text-brand-olive backdrop-blur">{event.category}</span>
      </div>
      <div className="p-5">
        <h3 className="font-display text-2xl font-bold tracking-wide text-white">{event.name}</h3>
        <div className="mt-3 space-y-1.5 text-sm text-slate-400">
          <p className="flex items-center gap-2"><MapPin size={14} className="text-brand-cyan" /> {event.destination}{event.state ? `, ${event.state}` : ""}</p>
          <p className="flex items-center gap-2"><CalendarDays size={14} className="text-brand-olive" /> {event.date_text}</p>
        </div>
        {event.distances?.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-1.5">
            {event.distances.map((d) => (
              <span key={d} className="rounded-md border border-brand-line bg-brand-ink/60 px-2 py-0.5 font-mono text-[11px] text-slate-300">{d}</span>
            ))}
          </div>
        )}
        {event.event_date && ["registration_open", "coming_soon"].includes(event.status) && (
          <div className="mt-3 flex items-center gap-2">
            <span className="font-mono text-[9px] tracking-[0.2em] text-slate-500">STARTS IN</span>
            <Countdown date={event.event_date} compact />
          </div>
        )}
        <div className="mt-5 flex items-center gap-3">
          <Link data-testid={`view-event-${event.slug}`} to={`/events/${event.slug}`} className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-cyan hover:gap-2.5 transition-all">
            VIEW EVENT <ArrowRight size={15} />
          </Link>
          {event.status === "registration_open" && (
            <button
              data-testid={`register-${event.slug}`}
              onClick={() => {
                if (event.registration_mode === "external" && event.registration_link) {
                  window.open(event.registration_link, "_blank");
                } else if (event.registration_mode === "onsite" && onRegister) {
                  onRegister(event);
                }
              }}
              className="ml-auto rounded-full bg-gradient-to-r from-brand-cyan to-brand-olive px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-brand-ink transition-transform hover:scale-105"
            >
              Register Now
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
